// @ts-nocheck
import { interactivityRegistration } from "./Charta";
import { EntityStore } from "./WebApp.Entity.Store";
import { FileStore } from "./WebApp.File_.Store";
import { application, setApplication } from "./WebApp.Instance";
import { PageHandler } from "./WebApp.Page";
import { ApplicationMode, WebSiteStore } from "./WebApp.Store";
import { SynchronizationCenter } from "./WebApp.Synchronization.Center";
import { ToastBox, ToastMessage } from "./WebApp.ToastBox";
import { UploadCenter } from "./WebApp.Upload.Center";
import { WebPageComponent } from "./WebSite.Page.Component";

export class Application {
  constructor() {
    this.rootUri = new URL("..", document.scripts[0].src);
    this.online = true;
    this.reloadOnControllerChange = false;
    this.updatePromptShown = false;

    this.store = new WebSiteStore();
    this.entityStore = new EntityStore();
    this.fileStore = new FileStore();

    this.pageHandler = new PageHandler(this.rootUri);
  }

  async prepare() {
    this.mode = await this.getMode();

    if ("serviceWorker" in navigator) {
      this.uploadCenter = new UploadCenter();
      this.synchronizationCenter = new SynchronizationCenter();

      this.startServiceWorker();

      setInterval(
        () => {
          this.assureServiceWorkerRunning();
        },
        5000
      );
    }

    this.toastBox = new ToastBox();

    this.pageHandler.initialize();
    this.pageHandler.start();
  }

  initialize() {
    if (this.uploadCenter) {
      this.uploadCenter.build();
      this.synchronizationCenter.initialize();
    }

    this.pageHandler.initialize();
    this.toastBox.initialize();
  }

  async getMode() {
    let mode = ApplicationMode.App;

    try {
      const value = await this.store.get("WebApp.Mode");

      if (value)
        mode = value;
    } catch (error) {
      console.error('Failed to load application mode from the database', error)
    }

    return mode;
  }

  setMode(value) {
    this.store.set("WebApp.Mode", value);
    this.mode = value;
  }

  async assureServiceWorkerRunning() {
    const serviceWorker = await navigator.serviceWorker.getRegistration();

    if (serviceWorker === undefined || serviceWorker.active === null)
      this.startServiceWorker();
    else
      serviceWorker.active.postMessage([]);
  }

  startServiceWorker() {
    const scope = this.resolve("ServiceWorker.js");

    navigator.serviceWorker.addEventListener("controllerchange", (event) => this.uploadCenter.connect(navigator.serviceWorker));
    navigator.serviceWorker.addEventListener("controllerchange", (event) => this.synchronizationCenter.connect(navigator.serviceWorker));
    navigator.serviceWorker.addEventListener("controllerchange", () => this.handleControllerChange());
    navigator.serviceWorker.register(scope, { updateViaCache: "none" })
      .then((registration) => {
        this.uploadCenter.connect(navigator.serviceWorker);
        this.synchronizationCenter.connect(navigator.serviceWorker);
        this.watchForUpdate(registration);
      });
  }

  handleControllerChange() {
    if (this.reloadOnControllerChange)
      window.location.reload();
  }

  watchForUpdate(registration) {
    if (registration.waiting && navigator.serviceWorker.controller)
      this.promptForUpdate(registration.waiting);

    registration.addEventListener(
      "updatefound",
      () => {
        const newWorker = registration.installing;

        if (newWorker) {
          newWorker.addEventListener(
            "statechange",
            () => {
              if (newWorker.state === "installed" && navigator.serviceWorker.controller)
                this.promptForUpdate(newWorker);
            }
          );
        }
      }
    );
  }

  promptForUpdate(worker) {
    if (!this.updatePromptShown) {
      this.updatePromptShown = true;

      this.toastBox.addMessage(new ToastMessage(this.pageHandler.labels.UpdateAvailable, "Hint"));

      this.reloadOnControllerChange = true;
      worker.postMessage({ Action: "SkipWaiting" });
    }
  }

  resolve(path) {
    return new URL(path, this.rootUri);
  }
}

window.onload = () => {
  setApplication(new Application());

  document.documentElement.component = new WebPageComponent(document.documentElement);
  interactivityRegistration.attach(document.body);

  application.prepare();
}
